// src/hooks/odakTuzagiYigini.ts
//
// AÇIK ODAK TUZAKLARININ YIĞINI — "Escape kimin?" sorusunun TEK cevabı.
//
// ── NEDEN VAR (ölçülmüş kullanıcı-görünür veri kaybı) ────────────────────
// `useFocusTrap` Escape'i `document`e CAPTURE fazında bağlar ve
// `e.stopPropagation()` çağırır. `stopPropagation` olayın BAŞKA DÜĞÜMLERE
// gitmesini durdurur; AYNI düğümdeki (burada: `document`) diğer dinleyicileri
// DURDURMAZ. Yani iki tuzak birden açıkken tek bir Escape ikisini de
// ateşliyordu — ölçüldü (`hooks/odakTuzagiYigini.test.tsx`, düzeltmeden önce):
//
//     dış katman onClose = 1   ·   iç katman onClose = 1
//
// Üründeki bedeli (`src/gonderiEtiketSeciciKapisi.render.test.tsx`,
// düzeltmeden önce `window.confirm` çağrı sayısı = 1): gönderi composer'ı
// açıkken etiket seçicide Escape → alttaki composer'ın *"Gönderi taslağın
// silinsin mi? Seçtiğin medya ve yazdıkların kaybolur."* onayı açılıyordu.
// Yanlışlıkla onaylayan kullanıcı TÜM gönderisini kaybediyordu.
//
// ── NEDEN «SON KAYDEDİLEN KAZANIR» TEK BAŞINA YETMEZ ─────────────────────
// React effect'leri AŞAĞIDAN YUKARI koşar. Dış ve iç katman AYNI commit'te
// mount olursa (cold-load, ya da bir üst bileşenin tek render'ı) İÇTEKİ ÖNCE
// kaydolur → "son kaydedilen" DIŞ katman olur ve sıra TERSİNE döner.
// Bu yüzden karar İKİ AŞAMALI:
//   1. DOM kapsaması: kabı, başka bir AÇIK tuzağın kabını İÇEREN katman
//      alttadır (üstteki, hiçbir açık tuzağı içermeyendir).
//   2. Kapsama ayırt etmiyorsa (kardeş katmanlar, portal'lar) kayıt sırası:
//      en son açılan kazanır.
//
// ── ÜÇ HÂL AYRI ──────────────────────────────────────────────────────────
// TEMİZ (tek tuzak / net üst) · İHLAL (alttaki Escape'i yutmaz) ·
// ÖLÇEMEDİM: aday kalmazsa (beklenmedik yığın hâli) ESKİ DAVRANIŞA düşülür
// (`true` döner) — yani yeni mekanizma bir belirsizlikte Escape'i sessizce
// ÖLDÜREMEZ. Kapalı yönün bedeli "modal Escape ile kapanmıyor" olurdu ve
// kullanıcı onu ✕ olmadan aşamazdı.

export type OdakTuzagiKaydi = { readonly kap: HTMLElement };

/** Açık tuzaklar, AÇILIŞ SIRASINA göre. Modül düzeyi: tek yığın, tek gerçek. */
const yigin: OdakTuzagiKaydi[] = [];

export function tuzagiKaydet(kap: HTMLElement): OdakTuzagiKaydi {
  const kayit: OdakTuzagiKaydi = { kap };
  yigin.push(kayit);
  return kayit;
}

export function tuzagiCikar(kayit: OdakTuzagiKaydi): void {
  const i = yigin.indexOf(kayit);
  if (i >= 0) yigin.splice(i, 1);
}

/**
 * Bu kayıt, şu an açık tuzaklar arasında EN ÜSTTEKİ mi?
 * (Escape'e yalnız o cevap verir.)
 */
export function enUsttekiTuzakMi(kayit: OdakTuzagiKaydi): boolean {
  // Tek tuzak: yığın devreye hiç girmez → 60+ mevcut katmanın davranışı BİREBİR
  // aynı kalır. (Yeni mekanizma yalnız iç içe/çoklu hâlde konuşur.)
  if (yigin.length <= 1) return true;
  const adaylar = yigin.filter(
    (a) => !yigin.some((b) => b !== a && a.kap !== b.kap && a.kap.contains(b.kap)),
  );
  if (adaylar.length === 0) return true; // ÖLÇEMEDİM → eski davranış
  return adaylar[adaylar.length - 1] === kayit;
}

/** Yalnız ölçüm/teşhis için: şu an kaç tuzak açık. */
export function acikTuzakSayisi(): number {
  return yigin.length;
}
